import reducer from "./reducer";
export { default as DocumentTemplates } from "./components/index";
export { default as documentTemplatesReducerName } from "./constants";
export default reducer;
